import type { DocMigration } from "../docMigration";

const roofPrefix = "roof.";
const modifierPrefix = "modifier.";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_184: DocMigration = {
  maxSchemaVersion: "0.0.184",
  description: "Fix failing Roof DocIntegrity checks",
  apply(json: any) {
    const { gableOpenings, roofs, modifiers, entityGroups } = json;

    // fix gable opening entity type
    for (const gableOpeningId in gableOpenings) {
      const gableOpening = gableOpenings[gableOpeningId];

      gableOpenings[gableOpeningId] = {
        ...gableOpening,
        entityType: "GABLE_OPENING",
      };
    }

    // fix roof entity type and parent neighbors
    for (const roofId in roofs) {
      const roof = roofs[roofId];
      let { parentNeighbors = [] } = roof;

      parentNeighbors = parentNeighbors.filter((neighborId) => roofs[neighborId]);

      if (parentNeighbors.length === 0) {
        parentNeighbors = undefined;
      }

      roofs[roofId] = {
        ...roof,
        parentNeighbors,
        entityType: "ROOF",
      };
    }

    // fix entity groups
    for (const entityGroupsId in entityGroups) {
      if (entityGroupsId.startsWith(roofPrefix)) {
        const roofId = entityGroupsId.slice(roofPrefix.length);

        if (!roofs[roofId]) {
          delete entityGroups[entityGroupsId];
        }
      } else if (entityGroupsId.startsWith(modifierPrefix)) {
        const modifierId = entityGroupsId.slice(modifierPrefix.length);

        if (!modifiers[modifierId]) {
          delete entityGroups[entityGroupsId];
        }
      }
    }

    return json;
  },
};

export default migration_0_0_184;
